import { render, staticRenderFns } from "./AppointmentPatient.vue?vue&type=template&id=1791810a&scoped=true&lang=pug&"
import script from "./AppointmentPatient.vue?vue&type=script&lang=js&"
export * from "./AppointmentPatient.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentPatient.vue?vue&type=style&index=0&id=1791810a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791810a",
  null
  
)

/* custom blocks */
import block0 from "./AppointmentPatient.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VForm,VProgressCircular,VRow,VTextField})
